import { convertFromRaw, Editor, EditorState } from "draft-js";
import React from "react";

interface ParagraphResponseProps {
  response: string;
}
const ParagraphResponse: React.FC<ParagraphResponseProps> = ({ response }) => {
  // Helper function to convert plain text to Draft.js format
  const convertTextToDraftJsFormat = (text: string) => {
    return {
      blocks: [
        {
          key: "initial",
          text: text,
          type: "unstyled",
          depth: 0,
          inlineStyleRanges: [],
          entityRanges: [],
          data: {}
        }
      ],
      entityMap: {}
    };
  };

  let editorState;

  try {
    // Handle different types of existing response
    if (!response) {
      editorState = EditorState.createEmpty();
    } else if (typeof response === 'string') {
      const trimmedResponse = response.trim();
      
      // Check if the string looks like it could be valid JSON
      if (trimmedResponse.length >= 3 && (trimmedResponse.startsWith('{') || trimmedResponse.startsWith('['))) {
        try {
          const parsedResponse = JSON.parse(response);
          // Validate that the parsed response has the expected structure for Draft.js
          if (parsedResponse && typeof parsedResponse === 'object' && parsedResponse.blocks && Array.isArray(parsedResponse.blocks)) {
            const contentState = convertFromRaw(parsedResponse);
            editorState = EditorState.createWithContent(contentState);
          } else {
            const draftJsFormat = convertTextToDraftJsFormat(response);
            const contentState = convertFromRaw(draftJsFormat);
            editorState = EditorState.createWithContent(contentState);
          }
        } catch (error) {
          const draftJsFormat = convertTextToDraftJsFormat(response);
          const contentState = convertFromRaw(draftJsFormat);
          editorState = EditorState.createWithContent(contentState);
        }
      } else {
        // It's plain text, convert to Draft.js format
        const draftJsFormat = convertTextToDraftJsFormat(response);
        const contentState = convertFromRaw(draftJsFormat);
        editorState = EditorState.createWithContent(contentState);
      }
    } else if (typeof response === 'object' && response !== null) {
      // If it's already an object, validate it has the expected structure
      const responseObj = response as any;
      if (responseObj.blocks && Array.isArray(responseObj.blocks)) {
        const contentState = convertFromRaw(responseObj);
        editorState = EditorState.createWithContent(contentState);
      } else {
        const draftJsFormat = convertTextToDraftJsFormat(JSON.stringify(response));
        const contentState = convertFromRaw(draftJsFormat);
        editorState = EditorState.createWithContent(contentState);
      }
    } else {
      // For other types (number, boolean, etc.), convert to text and then to Draft.js format
      const draftJsFormat = convertTextToDraftJsFormat(String(response));
      const contentState = convertFromRaw(draftJsFormat);
      editorState = EditorState.createWithContent(contentState);
    }
  } catch (error) {
    editorState = EditorState.createEmpty();
  }

  // Custom style map for inline styles (e.g., Bold and Underline)
  const customStyleMap = {
    BOLD: { fontWeight: "bold" },
    UNDERLINE: { textDecoration: "underline" },
  };

  // Style function for handling block types (e.g., H4, H5, H6)
  const blockStyleFn = (block: any) => {
    switch (block.getType()) {
      case "header-four":
        return "custom-header-four";
      case "header-five":
        return "custom-header-five";
      case "header-six":
        return "custom-header-six";
      default:
        return "";
    }
  };

  return (
    <div className="main-response-container">
      {/* @ts-ignore */}
      <Editor
        editorState={editorState}
        readOnly={true}
        onChange={() => {}}
        customStyleMap={customStyleMap}
        blockStyleFn={blockStyleFn}
      />
    </div>
  );
};

export default ParagraphResponse;
